import { createVoteUpdate } from '@module/helpers/centrifuge/messageUpdates';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { isVoteMessage, type VoteMessage } from '@module/types/centrifuge/public-message/voteMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class VoteHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<VoteMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isVoteMessage(payload);
  }

  handle(payload: VoteMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createVoteUpdate(payload, context.playInfo));
  }
}
